import { Dialog, Loader } from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";
import DialogUpdateManagerContent from ".";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { QUERY_KEY } from "../../../constants";
import { getManagers } from "../../../../../api/user";
import { _api_update_manager, api_update_new_manager } from "../../../api";
import styled from "styled-components";
import { DEVICE } from "../../../../../constants/responsive";
import { useToastGlobal } from "../../../../../stores/useToastGlobal";
import { useParams } from "react-router-dom";

const DialogUpdateManager = ({
    open_default = false,
    default_manager,
    onClose = () => console.log("Closed modal"),
}) => {
    const [managers, setManagers] = useState([]);
    const toast = useToastGlobal();

    const { id_employee } = useParams();

    const clientQuery = useQueryClient();

    const reset = () => {
        setManagers([]);
        onClose();
        refetchManagers();
        return;
    };

    const { isLoading: is_loading_managers, refetch: refetchManagers } =
        useQuery([QUERY_KEY + "::managers"], () => getManagers(), {
            refetchOnWindowFocus: false,
            onSuccess: (data) => {
                return setManagers(() => {
                    return data.map((manager) => {
                        return {
                            ...manager,
                            selected: manager?.id === default_manager?.id,
                        };
                    });
                });
            },
        });

    const {
        mutate: mutateUpdateManager,
        isLoading: isLoadingMutateUpdateManager,
    } = useMutation((data) => {
        return api_update_new_manager({
            user_ids: data.user_ids,
            manager_id: data.manager_id,
        });
    });

    // const {
    //     mutate: mutate_update_manager,
    //     isLoading: is_loading_update_manager,
    // } = useMutation(
    //     (manager_email) =>
    //         _api_update_manager({
    //             manager_email,
    //         }),
    //     {
    //         onSuccess: (data) => {
    //             if (data?.success) {
    //                 clientQuery.refetchQueries(QUERY_KEY + "::about");
    //                 return reset();
    //             }
    //         },
    //     }
    // );

    if (is_loading_managers && !managers?.length) {
        return <Loader content="chargement des managers ..." />;
    }

    const selected_manager = managers?.find((manager) => manager.selected)?.id;
    const is_same_manager = selected_manager === default_manager?.id;

    return (
        <DialogStyled
            open={open_default}
            onOpen={() => refetchManagers()}
            header="Modifier le Manager"
            content={
                <DialogUpdateManagerContent
                    managers={managers}
                    setManagers={setManagers}
                />
            }
            onCancel={reset}
            confirmButton={{
                content: "Valider le manager",
                flat: true,
                disabled: is_same_manager,
                loading: isLoadingMutateUpdateManager,
                onClick: () => {
                    return mutateUpdateManager(
                        {
                            user_ids: [id_employee],
                            manager_id: selected_manager,
                        },
                        {
                            onSuccess: (response) => {
                                // console.log({ response });
                                if (response?.success) {
                                    toast.setShow({
                                        content: "Manager Modifié",
                                        level: "success",
                                        visible: true,
                                        dismissible: true,
                                    });
                                    clientQuery.refetchQueries(
                                        QUERY_KEY + "::about"
                                    );
                                } else {
                                    toast.setShow({
                                        content:
                                            "Erreur lors de modification du manager",
                                        level: "danger",
                                        visible: true,
                                        dismissible: true,
                                    });
                                }
                            },
                        }
                    );
                    // return mutate_update_manager(selected_manager)
                },
            }}
            cancelButton={{
                content: "Annuler",
                flat: true,
            }}
        />
    );
};

export default DialogUpdateManager;

export const DialogStyled = styled(Dialog)`
    @media ${DEVICE.mobileS} {
        width: 300px;
    }
    @media ${DEVICE.mobileM} {
        width: 320px;
    }
    @media ${DEVICE.mobileL} {
        width: 391px;
    }
`;
